import React from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

export const REQUIREMENT_EXTRA_DEFAULTS = {
  numberOfPositions: '1',
  workMode: '',
  hiringManager: '',
  noticePeriodDays: '',
  expectedOnboardDate: '',
  interviewProcess: '',
  remarks: '',
};

export function buildRequirementExtraPayload(values = {}) {
  return {
    numberOfPositions: Number(values.numberOfPositions) || 1,
    workMode: values.workMode || '',
    hiringManager: values.hiringManager || '',
    noticePeriodDays: values.noticePeriodDays || '',
    expectedOnboardDate: values.expectedOnboardDate || undefined,
    interviewProcess: values.interviewProcess || '',
    remarks: values.remarks || '',
  };
}

function fieldStyle() {
  return {
    width: '300px',
    textAlign: 'center',
    margin: '10px',
    border: '1px solid gray',
    borderRadius: '15px',
  };
}

function RequirementExtraFields({ values, onChange }) {
  const set = (key) => (e) => onChange(key, e.target.value);

  return (
    <>
      <Form.Group as={Col}>
        <Form.Label><b>Number of Positions</b></Form.Label>
        <Form.Control
          type="number"
          min="1"
          value={values.numberOfPositions}
          onChange={set('numberOfPositions')}
          style={fieldStyle()}
          placeholder="e.g. 5"
        />
      </Form.Group>

      <Form.Group as={Col}>
        <Form.Label><b>Work Mode</b></Form.Label>
        <Form.Select value={values.workMode} onChange={set('workMode')} style={fieldStyle()}>
          <option value="">Choose...</option>
          <option value="Onsite">Onsite</option>
          <option value="Hybrid">Hybrid</option>
          <option value="Remote">Remote</option>
        </Form.Select>
      </Form.Group>

      <Form.Group as={Col}>
        <Form.Label><b>Hiring Manager</b></Form.Label>
        <Form.Control
          value={values.hiringManager}
          onChange={set('hiringManager')}
          style={fieldStyle()}
          placeholder="Hiring manager name"
        />
      </Form.Group>

      <Form.Group as={Col}>
        <Form.Label><b>Notice Period (Days)</b></Form.Label>
        <Form.Control
          value={values.noticePeriodDays}
          onChange={set('noticePeriodDays')}
          style={fieldStyle()}
          placeholder="e.g. 30"
        />
      </Form.Group>

      <Form.Group as={Col}>
        <Form.Label><b>Expected Onboard</b></Form.Label>
        <Form.Control
          type="date"
          value={values.expectedOnboardDate}
          onChange={set('expectedOnboardDate')}
          style={fieldStyle()}
        />
      </Form.Group>

      <Form.Group as={Col}>
        <Form.Label><b>Interview Process</b></Form.Label>
        <Form.Control
          value={values.interviewProcess}
          onChange={set('interviewProcess')}
          style={fieldStyle()}
          placeholder="HR Round → Technical → Client"
        />
      </Form.Group>

      <Form.Group as={Col}>
        <Form.Label><b>Remarks</b></Form.Label>
        <textarea
          value={values.remarks}
          onChange={set('remarks')}
          style={{ ...fieldStyle(), minHeight: '80px' }}
          placeholder="Additional notes"
        />
      </Form.Group>
    </>
  );
}

export default RequirementExtraFields;
